
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Pharmacy Details</h5>
                     </div><br>

                     <form @submit.prevent="profileUpdate" enctype="multipart/form-data">
                        <div>
                           <div class="row">
                              <div class="col-sm-4">
                                 <div class="mb-3">
                                    <label class="control-label">Name<span class="text-danger">*</span></label>
                                    <input class="form-control" type="text" v-model="name" placeholder=""  v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
                                    <!-- <input class="form-control" type="text" placeholder="" v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/> -->
                                                <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                                    <p class="mb-0">{{ val }}</p>
                                                </div>
                                 </div>
                              </div>
                              <div class="col-sm-4">
                                 <div class="mb-3">
                                    <label class="control-label">Email<span class="text-danger">*</span></label>
                                    <input class="form-control" type="text" v-model="email" placeholder=""  v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
                                    <!-- <input class="form-control" type="text" placeholder="" v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/> -->
                                                <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                                    <p class="mb-0">{{ val }}</p>
                                                </div>
                                 </div>
                              </div>
                              <div class="col-sm-4">
                                 <div class="mb-3">
                                    <label class="control-label">Phone <span class="text-danger">*</span></label>
                                    <div class="input-group">
                                       <div class="input-group-prepend">
                                          <select class="form-control" v-model="country_code_id" v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                             <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                          </select>
                                       </div>
                                       <input class="form-control" v-model="mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" @keypress="numbersOnly" maxlength="15" placeholder="Enter phone number">
                                    </div>
                                    <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                 <img class="avatar-md mb-2" v-if="image" :src="$image_url + image" alt="">
                                 <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                                 <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>
                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="deliverySetPlace" class="form-control"
                                 @keypress.enter="$event.preventDefault()" placeholder="Search here..."
                                 :value="delivery_location" />

                              <GmapMap v-if="delivery_location" :center="delivery_center" :zoom="18"
                                 map-style-id="delivery-roadmap" :options="delivery_mapOptions"
                                 style="width: 100%; height: 50vmin" ref="deliveryMapRef" @click="deliveryHandleMapClick">
                                 <GmapMarker :position="delivery_marker.position" :clickable="true" :draggable="true"
                                    @drag="deliveryHandleMarkerDrag" @click="deliveryPanToMarker" />
                              </GmapMap>
                           </b-col>

                           <div class="row">
                              <div class="col-sm-4">
                                 <div class="mb-3">
                                    <label class="control-label">Latitude<span class="text-danger">*</span></label>
                                    <input class="form-control" type="text" placeholder=""
                                       v-model="delivery_marker.position.lat" autocomplete="off"  v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"/>
                                       <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                       </div>
                                 </div>
                              </div>
                              <div class="col-sm-4">
                                 <div class="mb-3">
                                    <label class="control-label">Longitude<span class="text-danger">*</span></label>
                                    <input class="form-control" type="text" placeholder=""
                                       v-model="delivery_marker.position.lng" autocomplete="off"  v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"/>
                                       <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                       </div>
                                 </div>
                              </div>

                           </div>
                           <div class="col-sm-1" style="margin-top: 30px;">
                              <button type="submit" class="btn btn-primary">Update</button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>

               <div class="card">
                  <div class="card-body">
                     <div class="row">
                        <h5>Change password</h5>
                     </div><br>

                     <form role="form" @submit.prevent="updatePassword">
                        <div class="row">
                           <div class="col-sm-4">
                              <label class="control-label">Password</label>
                                 <div class="mb-3 input-group">
                                 <input class="form-control" v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="Enter your password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
                                 <div class="input-group-append ">
                                    <span class="input-group-text d-flex align-items-center" @click="togglePasswordVisibility">
                                          <i style="height: 1.5em;" :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                                    </span>
                                 </div>
                                 <!-- <input class="form-control" type="password" placeholder="" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/> -->
											<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
                              </div>
                           </div>
                           <div class="col-sm-4">
                                 <label class="control-label">Confirm Password</label>
                                 <div class="mb-3 input-group">
                                    <input class="form-control" v-model="password_confirmation" :type="showPasswordConfirmation ? 'text' : 'password'" placeholder="Enter your confirm password"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
                                    <div class="input-group-append">
                                       <span class="input-group-text d-flex align-items-center" @click="togglePasswordConfirmationVisibility">
                                          <i style="height: 1.5em;" :class="showPasswordConfirmation ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                                       </span>
                                    </div>

                                 <!-- <input class="form-control" type="Password" placeholder="" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>-->
											<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div> 
                              </div>
                           </div>

                           <div class="col-sm-1" style="margin-top: 30px;">
                              <button type="submit" class="btn btn-primary">Update</button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>



            </div>
         </div>
      </div>



   </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
   page: {
      title: "Profile",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
   },
   data() {
      return {
         title: "Profile", 
         items: [
            { text: "Home", href: "/" },
            { text: "Profile", active: true }
         ], 
         delivery_location: '',
         delivery_marker: { position: { lat: null, lng: null } },
         delivery_center: { lat: null, lng: null },
         delivery_current_place: null,

         
         delivery_mapOptions: {
            disableDefaultUI: true,
         },
         errors: {},
         password: '',
         password_confirmation: '',
         showPassword: false,
         showPasswordConfirmation: false,
         token: '',
         image:'',
         pharmacy_image:'',
         preview_image:'',
         name:'',
         email:'',
         mobile:'',

         countries: [],
         country_code_id: '',

          computed: {
          collectingRangeWithoutUnit() {
          return this.collecting_range.replace(/\s*km\s*$/, '');




    },
  },
      };
   },
       mounted() { 
       this.fetchCountryCodes().then(() => {
          this.fetchProfile();
       });
    },
    created() {
      
    },

        methods: {

       numbersOnly(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode > 31 && (charCode < 48 || charCode > 57)) {
             evt.preventDefault();
          } else {
             return true;
          }
       },

      fetchCountryCodes() {
           let url = "api/admin/get-countries";         
           this.getToken();
           return this.$axios
              .get(url, { headers: { Authorization: "Bearer " + this.token } })
              .then((res) => {
                 var responseData = res.data.data;
                 console.log(responseData);
                 this.countries = responseData.countries;
                 
              })
              .catch((err) => console.log(err));
        },

      togglePasswordVisibility() {
         this.showPassword = !this.showPassword;
      },

      togglePasswordConfirmationVisibility() {
        this.showPasswordConfirmation = !this.showPasswordConfirmation;
      },

      //sets the position of marker when dragged
      deliveryHandleMarkerDrag(e) {
         this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      },

      //Moves the map view port to marker
      deliveryPanToMarker() {
         this.$refs.deliveryMapRef.panTo(this.delivery_marker.position);
         this.$refs.deliveryMapRef.setZoom(18);
      },

      //Moves the marker to click position on the map
      deliveryHandleMapClick(e) {
         this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         console.log(e);
      },

      deliverySetPlace(place) {
         this.delivery_current_place = place;
         if (this.delivery_current_place) {
            const marker = {
               lat: this.delivery_current_place.geometry.location.lat(),
               lng: this.delivery_current_place.geometry.location.lng(),
            };
            this.delivery_center = marker;
            this.delivery_marker.position = marker;
            this.delivery_location = place.formatted_address;
         }
      },

      getToken() {
         if (localStorage.getItem('medicino_pharmacy')) {
            var medicino_pharmacy = JSON.parse(localStorage.getItem('medicino_pharmacy'));
            if (medicino_pharmacy.token) {
               this.token = medicino_pharmacy.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },

      updatePassword() {
         this.getToken();

         const config = {
            headers: {
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "pharmacy/change-password";

         let formData = new FormData();
         formData.append("id", this.$route.params.id);
         formData.append("password", this.password);
         formData.append("password_confirmation", this.password_confirmation);


         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.$router.push({ name: 'dashboard' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      },

      fetchProfile(){
          let url = "pharmacy/profile";
			this.getToken();
			this.loading = true;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					var data = res.data.data;
                var pharmacyData = data.pharmacy;
					console.log(pharmacyData);

               this.id = pharmacyData.id;
					this.name = pharmacyData.name;
					this.email = pharmacyData.email;
               this.mobile = pharmacyData.mobile;
               this.country_code_id = pharmacyData.country_code_id;
               this.delivery_location = pharmacyData.address;
                this.delivery_marker.position.lat = parseFloat(pharmacyData.latitude);
                this.delivery_marker.position.lng = parseFloat(pharmacyData.longitude);
                this.delivery_center = {
                  lat: parseFloat(pharmacyData.latitude),
                  lng: parseFloat(pharmacyData.longitude)
                };
               this.image = pharmacyData.image;

            })
				.catch((error) => {

					if (error.response) {
						if (error.response.data.message) {

							if (typeof error.response.data.message === 'object') {
								console.log(error.response.status);
							} else {
								this.$swal("", error.response.data.message, "error");
							}
						}
						else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}

				})
				.finally(() => (this.loading = false));
      },
      setFile(e) {
            this.pharmacy_image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },
      profileUpdate(){
         this.getToken();

         const config = {
            headers: {
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "pharmacy/profile/edit";

         let formData = new FormData();
         formData.append("id", this.id);
         formData.append("name", this.name);
         formData.append("email", this.email);
         formData.append("mobile", this.mobile);
         formData.append("country_code", this.country_code_id);
         formData.append("address", this.delivery_location);
         formData.append("latitude", this.delivery_marker.position.lat);
         formData.append("longitude", this.delivery_marker.position.lng);
         if(this.pharmacy_image) {
               formData.append('image', this.pharmacy_image);
            }

			this.$axios
			.post(url, formData, config)
            .then((response) => {
               console.log(response);
               if (response.data.status) {
                     var user = response.data.data;
                     console.log(user);
                     var medicino_pharmacy = {};
                     if (localStorage.getItem('medicino_pharmacy')) {
                        medicino_pharmacy =  JSON.parse(localStorage.getItem('medicino_pharmacy'));
                     }
                     medicino_pharmacy.image = user.image;
                     medicino_pharmacy.name = user.name;

                     localStorage.setItem('medicino_pharmacy', JSON.stringify(medicino_pharmacy));
                     
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
               this.$router.go().catch(()=>{});
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     // this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  // this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      },


   },

}


</script>